import React from 'react';
import classnames from 'classnames';
import Sticky from '@wix/da-shared-react/pkg/Sticky';
import shortenNumber from '@wix/da-shared-react/pkg/utils/shortenNumber';
import { BiDataHook } from '@wix/da-shared-react/pkg/biLogger';

import cssVars from '@wix/da-shared-react/src/styles/variables.scss';
import profilesCssVars from '../../../../styles/variables.scss';
import s from './WidgetHeaderMobile.scss';

export interface Props {
  header: string | React.ReactNode;
  count?: number | string;
  extras?: React.ReactNode | React.ReactNode[];
  extrasWhenSticky?: React.ReactNode | React.ReactNode[];
  isSticky?: boolean;
  className?: string;
  rootClassName?: string;
}

export class WidgetHeaderMobile extends React.Component<Props> {
  render() {
    const { className, isSticky } = this.props;
    const marginTop =
      parseInt(cssVars['site-header-height-mobile']) +
      parseInt(profilesCssVars['mobile-navbar-height']);
    return (
      <div className={classnames(s['wrapper'], className)}>
        {isSticky ? (
          <Sticky className={'sticky'} marginTop={marginTop}>
            {isStuck => this.renderInner(isStuck)}
          </Sticky>
        ) : (
          this.renderInner()
        )}
      </div>
    );
  }
  renderInner(isStuck = false) {
    const {
      header,
      count,
      extras,
      extrasWhenSticky,
      rootClassName,
    } = this.props;
    return (
      <div
        className={classnames(
          s['root'],
          isStuck && s['is-stuck'],
          rootClassName
        )}
      >
        <h2 className={s['header']} data-hook={BiDataHook.WIDGET_HEADER}>
          {header}
          {!!count && (
            <span
              className={s['count']}
              data-hook={BiDataHook.WIDGET_HEADER_COUNTER}
            >
              {shortenNumber(count)}
            </span>
          )}
        </h2>
        {extras}
        {isStuck && extrasWhenSticky}
      </div>
    );
  }
}

export default WidgetHeaderMobile;
